import React from 'react';
import { motion } from 'framer-motion';
import { Construction, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const WorkInProgress = () => {
return (
    <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8">
        <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-md w-full space-y-8 p-10 rounded-xl shadow-2xl dark:shadow-gray-900/20"
        >
            <div>
                <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ delay: 0.2, type: 'spring', stiffness: 260, damping: 20 }}
                    className="mx-auto flex items-center justify-center h-24 w-24 rounded-full bg-primary-100"
                >
                    <Construction className="h-12 w-12 text-primary-600" />
                </motion.div>
                <motion.h2
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.4, duration: 0.8 }}
                    className="mt-6 text-center text-3xl font-extrabold text-gray-900"
                >
                    Work in Progress
                </motion.h2>
                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.6, duration: 0.8 }}
                    className="mt-2 text-center text-sm text-gray-600"
                >
                    We're working hard to bring you something amazing. Please check back soon!
                </motion.p>
            </div>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.8, duration: 0.8 }}
                className="mt-8 space-y-6"
            >
                <div className="flex flex-col space-y-4">
                    <div className="flex items-center justify-between px-4 py-3 bg-primary-50 rounded-lg">
                        <span className="text-sm font-medium text-primary-700">Progress</span>
                        <span className="text-sm font-medium text-primary-700">65%</span>
                    </div>
                    <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2.5">
                        <motion.div 
                            className="bg-primary-600 h-2.5 rounded-full"
                            initial={{ width: 0 }}
                            animate={{ width: '65%' }}
                            transition={{ delay: 1, duration: 1.5, ease: 'easeOut' }}
                        ></motion.div>
                    </div>
                </div>
                <Link
                    to="/"
                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm dark:shadow-gray-900/20 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition duration-150 ease-in-out"
                >
                    <ArrowLeft className="h-5 w-5 mr-2" />
                    Return Home
                </Link>
            </motion.div>
        </motion.div>
    </div>
);
};

export default WorkInProgress;